/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TherapyEndReasonEnum } from './therapyEndReasonEnum';
import { PatchedPatientMasterDataUpdateStripeEmail } from './patchedPatientMasterDataUpdateStripeEmail';
import { DigaEnum } from './digaEnum';
import { BillingTypeEnum } from './billingTypeEnum';


/**
 * The master data a TPM user may edit; every change is written back to CRM and Creator.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface PatchedPatientMasterDataUpdate { 
    dob?: string | null;
    street?: string;
    houseNumber?: string;
    addressAddition?: string;
    postalCode?: string;
    city?: string;
    phone?: string;
    note?: string;
    digas?: Array<DigaEnum>;
    therapyEnded?: boolean;
    therapyEndReason?: TherapyEndReasonEnum | null;
    therapyEndReasonOther?: string;
    sessionsPerWeek?: string | null;
    invirtoDataSharingConsentOn?: string | null;
    coTherapist?: string;
    billingType?: BillingTypeEnum | null;
    healthInsurance?: number | null;
    insuranceNumber?: string;
    stripeEmail?: PatchedPatientMasterDataUpdateStripeEmail;
    discount?: string | null;
    withholdDocumentationOnTherapistChange?: boolean;
    confidentialityRelease?: boolean;
    bvDvConsentObtained?: boolean;
    kbReviewed?: boolean;
}
export namespace PatchedPatientMasterDataUpdate {
}

export const PatchedPatientMasterDataUpdate_dob_Validators: ValidatorFn[] =
    [ ];

export const PatchedPatientMasterDataUpdate_street_Validators: ValidatorFn[] =
    [  Validators.maxLength(255),];

export const PatchedPatientMasterDataUpdate_houseNumber_Validators: ValidatorFn[] =
    [  Validators.maxLength(31),];

export const PatchedPatientMasterDataUpdate_addressAddition_Validators: ValidatorFn[] =
    [  Validators.maxLength(255),];

export const PatchedPatientMasterDataUpdate_postalCode_Validators: ValidatorFn[] =
    [  Validators.maxLength(10),];

export const PatchedPatientMasterDataUpdate_city_Validators: ValidatorFn[] =
    [  Validators.maxLength(255),];

export const PatchedPatientMasterDataUpdate_phone_Validators: ValidatorFn[] =
    [  Validators.maxLength(63),];

export const PatchedPatientMasterDataUpdate_note_Validators: ValidatorFn[] =
    [ ];

export const PatchedPatientMasterDataUpdate_digas_Validators: ValidatorFn[] =
    [ ];

export const PatchedPatientMasterDataUpdate_therapyEnded_Validators: ValidatorFn[] =
    [ ];

export const PatchedPatientMasterDataUpdate_therapyEndReason_Validators: ValidatorFn[] =
    [ ];

export const PatchedPatientMasterDataUpdate_therapyEndReasonOther_Validators: ValidatorFn[] =
    [  Validators.maxLength(1023),];

export const PatchedPatientMasterDataUpdate_sessionsPerWeek_Validators: ValidatorFn[] =
    [  Validators.pattern('/^-?\\d{0,2}(?:\\.\\d{0,2})?$/'),];

export const PatchedPatientMasterDataUpdate_invirtoDataSharingConsentOn_Validators: ValidatorFn[] =
    [ ];

export const PatchedPatientMasterDataUpdate_coTherapist_Validators: ValidatorFn[] =
    [  Validators.maxLength(255),];

export const PatchedPatientMasterDataUpdate_billingType_Validators: ValidatorFn[] =
    [ ];

export const PatchedPatientMasterDataUpdate_healthInsurance_Validators: ValidatorFn[] =
    [ ];

export const PatchedPatientMasterDataUpdate_insuranceNumber_Validators: ValidatorFn[] =
    [  Validators.maxLength(31),];

export const PatchedPatientMasterDataUpdate_stripeEmail_Validators: ValidatorFn[] =
    [ ];

export const PatchedPatientMasterDataUpdate_discount_Validators: ValidatorFn[] =
    [  Validators.pattern('/^-?\\d{0,3}(?:\\.\\d{0,2})?$/'),];

export const PatchedPatientMasterDataUpdate_withholdDocumentationOnTherapistChange_Validators: ValidatorFn[] =
    [ ];

export const PatchedPatientMasterDataUpdate_confidentialityRelease_Validators: ValidatorFn[] =
    [ ];

export const PatchedPatientMasterDataUpdate_bvDvConsentObtained_Validators: ValidatorFn[] =
    [ ];

export const PatchedPatientMasterDataUpdate_kbReviewed_Validators: ValidatorFn[] =
    [ ];


